import { OperationError } from "./DAO";

function digits2(num: number): string {
   return num < 10 ? "0" + num : "" + num;
}

export function formatIsoDate(date: Date | null): string {
   if (date != null) {
      return [date.getFullYear(), digits2(date.getMonth() + 1), digits2(date.getDate())].join("-");
   }
   return "";
};

export function formatIsoDateTime(date: Date | null): string {
   if (date != null) {
      return formatIsoDate(date) + " " + [date.getHours(), date.getMinutes()].map(digits2).join(":");
   }
   return "";
};

export function strictParseDate(value: string | null): Date | null {
   if (value) {
      const groups = value.match(/^(?<year>\d{4})\-(?<month>\d{2})\-(?<day>\d{2})$/);
      if (groups?.length === 4) {
         const year = +groups[1], month = +groups[2], day = +groups[3];
         if (year > 1900 && month > 0 && month < 13) {
            return new Date(year, month - 1, day, 0, 0, 0, 0);
         }
      }
      throw new OperationError().addIssue({
         code: 'PARSE_INPUT'
      });
   }
   return null;
}
